import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import swal from '@sweetalert/with-react';
import PageTitle from '../../organisms/pageTitle/pageTitle';
import FormGroup from '../../organisms/formGroup/formGroup2';
import FooterButton from '../../molecules/formFooter/formFooter';
import FormAppearanceGlobalAssets from '../../../config/formAppearanceGlobalAssets';
import FormAppearanceWhitelabelWeb from '../../../config/formAppearanceWhitelabelWeb';
import FormAppearanceWhitelabelPlay from '../../../config/formAppearanceWhitelabelPlay';
import { storeStructure } from '../../../store/reducers';
import { mapDispatchToProps } from '../../../store/externalCalls/api/appearanceApi';
import routes, { getLink } from '../../../routes/route';
import { useNavigate, useLocation } from 'react-router-dom';
const AppearanceTemplate = (props) => {
  const {
    getItem,
    saveItem,
    resetForm,
    history,
    fileType,
  } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const session = useSelector((state) => state[storeStructure.Session]);
  const appearanceGlobalAssets = useSelector(
    (state) => state[storeStructure.AppearanceGlobalAssets],
  );
  const [localAppearance, setlocalAppearance] = useState();

  const handlerOnChange = (valueChanged) => {
    const newApperance = { ...localAppearance, ...valueChanged };
    setlocalAppearance(newApperance);
    saveItem(session, { appearanceGlobalAsset: newApperance });
  };
  useEffect(() => {
    if (session.appId !== undefined && session.areaId !== undefined) {
      getItem(session.appId, session.areaId).then(() => { }, () => {
        resetForm();
        navigate(getLink(routes.HOME_PAGE), {
          state: {
            from: location.pathname,
          },
        });
      });
    }
  }, [session.appId, session.areaId, getItem]);

  useEffect(() => {
    if (appearanceGlobalAssets[0]) {
      setlocalAppearance(appearanceGlobalAssets[0]);
    }

    return () => {
      setlocalAppearance();
    };
  }, [appearanceGlobalAssets]);

  return (
    <div>
      <PageTitle>Appearance</PageTitle>
      <FormGroup
        key="videoContentVideoTemplate-1"
        configFile={FormAppearanceGlobalAssets}
        value={localAppearance}
        onChange={handlerOnChange}
        fileType={fileType}
      />
      <FormGroup
        key="videoContentVideoTemplate-2"
        configFile={FormAppearanceWhitelabelWeb}
        value={localAppearance}
        onChange={handlerOnChange}
      />
      <FormGroup
        key="videoContentVideoTemplate-3"
        configFile={FormAppearanceWhitelabelPlay}
        value={localAppearance}
        onChange={handlerOnChange}
      />
    </div>
  );
};

AppearanceTemplate.propTypes = {
  getItem: PropTypes.func.isRequired,
  saveItem: PropTypes.func.isRequired,
  resetForm: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default (connect(null, mapDispatchToProps)(AppearanceTemplate));
